import {
    VOLMA_SIGNALR_INVOKE,
    VOLMA_SIGNALR_START_CONNECTION,
    VOLMA_SIGNALR_STATE_CHANGED,
    VOLMA_SIGNALR_STOP_CONNECTION
} from '../../Constants/AppConstants';
import { ECQRSApi } from '../ServerInteraction/ECQRSApi';
import { UrlFabric } from '../ServerInteraction/UrlFabric';
import { HttpTransportType, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';

const reconnectDelay = 10000;

export const connection = new HubConnectionBuilder()
    .withUrl(`${UrlFabric.GetApiBaseUrl(ECQRSApi.Read)}/VolmaSPAHub`)
    .configureLogging(LogLevel.Information)
    .build();

export default function createSignalrMiddleware(actionDispatcher) {
    return store => {

        const dispatch = store.dispatch.bind(store)

        var currentState: HubConnectionState = null

        actionDispatcher(dispatch, connection);

        connection.onclose(() => {
            reconnect();
        });

        function onStateChanged(state: HubConnectionState) {
            if (currentState === state) {
                return;
            }

            currentState = state;

            dispatch({
                type: VOLMA_SIGNALR_STATE_CHANGED,
                state: state,
            });
        }

        function connect() {
            onStateChanged(HubConnectionState.Connecting);

            connection.start().then(() => {
                console.log(`SignalR: connectionId ${connection.connectionId}`);
                onStateChanged(HubConnectionState.Connected);
                connection.invoke("Ping", "Natasha");
            }).catch(err => {
                reconnect();
            });
        }

        function reconnect() {
            onStateChanged(HubConnectionState.Connecting);

            setTimeout(() => connect(), reconnectDelay);
        }

        function disconnect() {
            connection.stop().then(() => {
                onStateChanged(HubConnectionState.Disconnected);
            });
        }

        function invoke(action) {
            const { method, args } = action;
            connection.invoke(method, ...args);
        }

        return next => action => {
            const { type } = action;
            switch (type) {
                case VOLMA_SIGNALR_START_CONNECTION:
                    connect();
                    return;
                case VOLMA_SIGNALR_STOP_CONNECTION:
                    disconnect();
                    return;
                case VOLMA_SIGNALR_INVOKE:
                    invoke(action);
                    return;
                default:
                    return next(action);
            }
        };
    };
}